import useSWR from "swr"
import {API_ECP_PROJECTS} from "../constants/apiUrls"

export default function useEcpProject(projectId) {
    const {data, mutate, error} = useSWR(`${API_ECP_PROJECTS}/${projectId}`)
    return {
        ecpProject: data,
        mutateEcpProject: mutate,
        isLoadingEcpProject: !error && !data,
        isErrorEcpProject: error
    }
}